<template>
  <div class="cloudPhone pointer">
    <!-- <div class="initTransition" v-if="transitionShow">
      <div class="text">正在打开云手机...</div>
    </div> -->
    <transition name="Fade">
      <img
        v-if="transitionShow"
        class="phoneBack1"
        src="@/assets/imgs/phoneBack2.png"
        alt=""
      />
    </transition>
    <transition name="textFade">
      <div v-if="transitionShow" class="text1">正在打开云手机...</div>
    </transition>
    <div
      :class="[
        'phoneBox',
        menuShow ? '' : 'phoneBox_menu',
        isFloat ? 'phoneBox_qp' : '',
      ]"
    >
      <div
        id="phoneBoxId"
        style="
          overflow: hidden;
          width: 100% !important;
          height: 100% !important;
        "
      ></div>
    </div>
    <div class="head" v-if="!isFloat">
      <div class="headLeft">
        <!-- 切换云手机 -->
        <van-popover
          placement="bottom"
          v-model="showPopover"
          trigger="click"
          theme="dark"
          class="group-popover"
        >
          <div :class="['group-list']">
            <div
              :class="[
                'ellipsis',
                'item',
                item.instanceCode == instanceCode ? 'active' : '',
              ]"
              v-for="item in allEquipmentArr"
              :key="item.id"
              @click="onCutPhone(item)"
            >
              <span class="deviceType">{{
                getDeviceType(
                  item.vipCode,
                  item.deviceVersionCode,
                  item.vipName
                )
              }}</span>
              {{ item.instanceName }}
            </div>
          </div>
          <template #reference>
            <div class="groupNowadayBox">
              <div class="groupNowaday">
                <span class="deviceType">{{
                  getInstanceType(instanceCode)
                }}</span>
                {{ getInstanceName(instanceCode) }}
              </div>
              <img
                class="direction"
                v-if="showPopover"
                src="@/assets/icons/direction-up.png"
                alt=""
              />
              <img
                class="direction"
                v-else
                src="@/assets/icons/direction-bottom.png"
                alt=""
              />
            </div>
          </template>
        </van-popover>
        <!-- 切换清晰度 -->
        <van-popover
          placement="bottom"
          v-model="showOdefinition"
          trigger="click"
          theme="dark"
          class="group-popover popover-odefinition"
        >
          <div class="group-list odefinition-list">
            <div
              :class="[
                'ellipsis',
                'item',
                item.id == odefinitionValue ? 'active' : '',
              ]"
              v-for="item in odefinitionOptions"
              :key="item.id"
              @click="onCutOdefinition(item.id)"
            >
              {{ item.name }}
            </div>
          </div>
          <template #reference>
            <div class="groupNowadayBox">
              <div class="groupNowaday">
                <span> {{ getOdefinition(odefinitionValue) }}</span>
                <span
                  :class="[
                    netDelay < 50 ? 'btn_lv' : '',
                    netDelay >= 50 && netDelay < 200 ? 'btn_huang' : '',
                    netDelay >= 200 ? 'btn_hong' : '',
                  ]"
                >
                  {{ netDelay }}ms</span
                >
              </div>
              <img
                class="direction"
                v-if="showOdefinition"
                src="@/assets/icons/direction-up.png"
                alt=""
              />
              <img
                class="direction"
                v-else
                src="@/assets/icons/direction-bottom.png"
                alt=""
              />
            </div>
          </template>
        </van-popover>
      </div>
      <div class="headerRight" @click="handleMenuShow()">
        <img v-show="menuShow" src="@/assets/icons/spread.png" alt="" />
        <img v-show="!menuShow" src="@/assets/icons/packUp.png" alt="" />
      </div>
    </div>
    <div
      :class="[
        'sidebar',
        'scroll-wrapper',
        direction ? 'directionDegrees' : '',
      ]"
      v-if="menuShow && !isFloat"
    >
      <div
        v-for="item in menuResult"
        :key="item.text"
        :class="['lastItem', item.text == '摇一摇' ? 'lastItemShake' : '']"
      >
        <div class="last" v-if="item.checked" @click="menuRorClick(item.text)">
          <div>
            <img :src="item.src" alt="" />
            <!-- <div>{{ item.text }}</div> -->
          </div>
        </div>
      </div>
      <div class="last" @click="menuRorClick('退出')">
        <img src="@/assets/icons/quitImg.png" alt="" />
        <!-- <div>退出</div> -->
      </div>
    </div>
    <div class="base" v-if="!isFloat">
      <div @click="ysjclick('home')">
        <img src="@/assets/icons/cut.png" alt="" />
      </div>
      <div @click="ysjclick('zhuomian')">
        <img src="@/assets/icons/desktop.png" alt="" />
      </div>
      <div @click="ysjclick('fanhui')">
        <img src="@/assets/icons/getBack.png" alt="" />
      </div>
    </div>
    <Floating
      v-if="isFloat"
      @xuanfuchuan="xuanfuchuan"
      :netDelay="netDelay"
      :floatPhone="floatPhone"
    />
    <!-- 悬浮窗打开的控制台 -->
    <van-popup
      v-model="consoleShow"
      :position="direction ? 'top' : 'left'"
      :class="['popupConsole', direction ? 'topDirection' : 'leftDirection']"
      v-if="isFloat"
    >
      <div class="consoleTop">
        <div class="card">
          <div class="top">
            <div class="left">
              <img class="ico" src="@/assets/logo.png" alt="" />
              <div class="detail">
                <p class="alias">
                  <span class="deviceType">{{
                    getDeviceType(
                      atInstance.vipCode,
                      atInstance.deviceVersionCode,
                      atInstance.vipName
                    )
                  }}</span>
                  {{ atInstance.instanceName }}
                </p>
                <div class="id">ID {{ atInstance.id }}</div>
              </div>
            </div>
            <div class="control">
              <div class="fresh" @click="handleRefresh">
                <span class="freshImgicon"></span><span class="name">刷新</span>
              </div>
              <div
                class="quitFloat fresh"
                @click="screenSize(false), (consoleShow = false)"
              >
                <span class="imgicon"></span><span class="name">关闭全屏</span>
              </div>
            </div>
          </div>
        </div>
        <div class="cardTwo">
          <div class="partTop">
            <div
              v-for="item in menuResult"
              :key="item.text"
              v-if="item.checked && item.text != '刷新' && item.text != '全屏'"
            >
              <div class="last" @click="menuRorClick(item.text)">
                <div class="icoBox">
                  <img class="ico" :src="item.src" alt="" />
                </div>
                <div class="text">{{ item.text }}</div>
              </div>
            </div>
            <div>
              <div class="last" @click="menuRorClick('退出')">
                <div class="icoBox">
                  <img class="ico" src="@/assets/icons/quitImg.png" alt="" />
                </div>
                <div class="text">退出</div>
              </div>
            </div>
          </div>
          <div class="partBottom">
            <div class="ysjcBox">
              <div class="common" @click="ysjclick('home')">
                <img src="@/assets/icons/fullCut.png" alt="" />
                <div>切换</div>
              </div>
              <div class="common" @click="ysjclick('zhuomian')">
                <img src="@/assets/icons/fullDesktop.png" alt="" />
                <div>桌面</div>
              </div>
              <div class="common" @click="ysjclick('fanhui')">
                <img src="@/assets/icons/fullReturn.png" alt="" />
                <div>返回</div>
              </div>
            </div>
          </div>
        </div>
        <div class="cardThree">
          <!-- 切换云手机 -->
          <van-popover
            :placement="direction ? 'left' : 'bottom'"
            v-model="showPopover"
            trigger="click"
            theme="dark"
            class="group-popover"
          >
            <div
              :class="[
                'group-list',
                !direction ? 'group-list-bottom' : 'group-list-left',
              ]"
            >
              <div
                :class="[
                  'ellipsis',
                  'item',
                  item.id == innerGroupId ? 'active' : '',
                ]"
                v-for="item in globalAllGroupList"
                :key="item.id"
                @click="onGroupItem(item.id)"
              >
                {{ item.groupName }}({{ item.instanceList.length }})
              </div>
            </div>
            <template #reference>
              <div class="groupNowadayBox">
                <div class="groupNowaday" v-if="getGroupItem(innerGroupId)">
                  {{ getGroupItem(innerGroupId).groupName }}({{
                    getGroupItem(innerGroupId).instanceList.length
                  }})
                </div>
                <img
                  class="direction"
                  v-if="showPopover"
                  src="@/assets/icons/direction-up.png"
                  alt=""
                />
                <img
                  class="direction"
                  v-else
                  src="@/assets/icons/direction-bottom.png"
                  alt=""
                />
              </div>
            </template>
          </van-popover>
          <!-- 切换清晰度 -->
          <van-popover
            :placement="direction ? 'left' : 'bottom'"
            v-model="showOdefinition"
            trigger="click"
            theme="dark"
            class="group-popover popover-odefinition"
          >
            <div
              :class="[
                'group-list ',
                'odefinition-list',
                !direction ? 'group-list-bottom' : 'group-list-left',
              ]"
            >
              <div
                :class="[
                  'ellipsis',
                  'item',
                  item.id == odefinitionValue ? 'active' : '',
                ]"
                v-for="item in odefinitionOptions"
                :key="item.id"
                @click="onCutOdefinition(item.id)"
              >
                {{ item.name }}
              </div>
            </div>
            <template #reference>
              <div class="groupNowadayBox">
                <div class="groupNowaday">
                  <span> {{ getOdefinition(odefinitionValue) }}</span>
                  <span
                    :class="[
                      netDelay < 50 ? 'btn_lv' : '',
                      netDelay >= 50 && netDelay < 200 ? 'btn_huang' : '',
                      netDelay >= 200 ? 'btn_hong' : '',
                    ]"
                  >
                    {{ netDelay }}ms</span
                  >
                </div>
                <img
                  class="direction"
                  v-if="showOdefinition"
                  src="@/assets/icons/direction-up.png"
                  alt=""
                />
                <img
                  class="direction"
                  v-else
                  src="@/assets/icons/direction-bottom.png"
                  alt=""
                />
              </div>
            </template>
          </van-popover>
        </div>
      </div>
      <div class="consoleBottom">
        <div
          v-for="item in getGroupItem(innerGroupId).instanceList"
          :key="item.id"
          :class="[
            'shebei_title',
            item.instanceCode == instanceCode ? 'active' : '',
          ]"
          @click="onCutPhone(item)"
        >
          <div class="shebei_content">
            <p class="p1">
              <span class="deviceType">{{
                getDeviceType(
                  item.vipCode,
                  item.deviceVersionCode,
                  item.vipName
                )
              }}</span>
              {{ item.instanceName }}
            </p>
            <div class="p2">
              <p class="id">ID {{ item.instanceId }}</p>
            </div>
          </div>
          <div class="instanceItem">
            <div
              class="devices-status"
              v-if="item.instanceCode == instanceCode"
            >
              <div class="status-div-normal"></div>
              <span class="status-span-normal">运行中</span>
            </div>
            <div>剩余时间：{{ formatSeconds(item.expireSeconds) }}</div>
          </div>
        </div>
      </div>
    </van-popup>
    <secondConfirm
      :showDialog.sync="showDialog"
      content="是否确定重启云手机？重启期间无法进行其他操作！"
      @affirm="dialogConfim"
      :direction="direction"
    ></secondConfirm>
    <ShearPlate
      :showDialog.sync="shearShow"
      @affirm="confirmModel"
      :direction="direction"
    ></ShearPlate>
    <dialogHint
      :dialogShow="dialogShow"
      :dialogTitle="dialogTitle"
      @dialogClic="confirms"
      :direction="direction"
    >
      <template v-slot:content>{{ dialogName }}</template>
    </dialogHint>
    <van-popup
      :close-on-click-overlay="false"
      v-model="shakeShow"
      class="shakePopup"
    >
      <div class="shakeContent">
        <img
          class="shakeAnimation"
          src="@/assets/icons/shakeAnimation.png"
          alt=""
        />
      </div>
    </van-popup>
  </div>
</template>
  
  <script>
import { commandreboot } from "@/api/instance/index";
import { Toast } from "vant";
import { serverToken } from "@/api/instance";
import { mapState, mapMutations } from "vuex";
import ArmcloudEngine from "@/utils/pkg";
import Floating from "@/components/Floating.vue";
import secondConfirm from "@/components/publicDialog/secondConfirm.vue";
import dialogHint from "@/components/publicDialog/dialogHint.vue";
import ShearPlate from "@/components/cloudPhone/ShearPlate.vue";
import buyCode from "@/utils/buyCode";
import { instancelist, groupList, hsOrBdScreenshot } from "@/api/index.js";
export default {
  name: "CloudPhone",
  components: {
    Floating,
    secondConfirm,
    dialogHint,
    ShearPlate,
  },
  data() {
    return {
      instanceCode: "",
      instanceType: 0,
      netDelay: 0,
      userdata: {},
      menuShow: true,
      menuResult: [
        {
          checked: true,
          text: "刷新",
          src: require("@/assets/icons/shuaxin1.png"),
        },
        {
          checked: true,
          text: "全屏",
          src: require("@/assets/icons/fullScreenImg.png"),
        },
        {
          checked: true,
          text: "截图",
          src: require("@/assets/icons/printscreen.png"),
        },
        {
          checked: true,
          text: "音量+",
          src: require("@/assets/icons/volumePlus.png"),
        },
        {
          checked: true,
          text: "音量-",
          src: require("@/assets/icons/volumeReduction.png"),
        },
        {
          checked: true,
          text: "剪切板",
          src: require("@/assets/icons/shearPlateImg.png"),
        },
        {
          checked: true,
          text: "摇一摇",
          src: require("@/assets/icons/shake.png"),
        },
        {
          checked: true,
          text: "重启",
          src: require("@/assets/icons/restartImg.png"),
        },
      ],
      isFloat: false,
      floatPhone: { id: this.$route.query.instanceCode },
      allEquipmentArr: [],
      showPopover: false,
      showOdefinition: false,
      odefinitionOptions: [
        { id: 0, name: "流畅 360P" },
        { id: 1, name: "标清 540P" },
        { id: 2, name: "高清 720P" },
      ],
      odefinitionValue: 2,
      consoleShow: false,
      innerGroupId: -1,
      atInstance: {},
      armCloud: null,
      serverTokenData: {},
      showDialog: false,
      shearShow: false,
      transitionShow: true,
      dialogShow: false,
      dialogTitle: "提示",
      dialogName: "",
      direction: 0,
      shakeShow: false,
      channelCodeOptions: [
        {
          label: "百度",
          value: "baidu",
          type: 0,
        },
        {
          label: "智能云",
          value: "intelligent",
          type: 1,
        },
        {
          label: "火山",
          value: "huoshan",
          type: 2,
        },
        {
          label: "华为",
          value: "huawei",
          type: 3,
        },
      ],
    };
  },
  mounted() {
    this.instanceCode = this.$route.query.instanceCode;
    this.handleisFullScreen();
    if (this.globalAllGroupList.length > 0) {
      this.handAllEquipmentArr();
      this.getserverToken();
    } else {
      this.getInstancelist();
    }

    this.innerGroupId = this.groupId;
    this.odefinitionValue = this.handleInitOdefinition();
  },
  watch: {
    $route(to, from) {
      if (to.query.instanceCode) {
        this.armCloud.destroyedInstance();
        this.transitionShow = true;
        this.instanceCode = this.$route.query.instanceCode;
        this.handleisFullScreen();
        if (this.globalAllGroupList.length > 0) {
          this.handAllEquipmentArr();
          this.getserverToken();
        } else {
          this.getInstancelist();
        }
        this.innerGroupId = this.groupId;
        this.odefinitionValue = this.handleInitOdefinition();
      }
    },
  },
  destroyed() {
    this.armCloud.destroyedInstance();
  },
  computed: {
    ...mapState("perpetual", ["groupId", "fullScreen", "initOdefinition"]),
    ...mapState("common", ["globalAllGroupList"]),
    getInstanceName: {
      get() {
        return function (instanceCode) {
          let item = this.allEquipmentArr.find(
            (item) => item.instanceCode == instanceCode
          );
          if (item) {
            return item.instanceName;
          }
        };
      },
    },
    getInstanceType: {
      get() {
        return function (instanceCode) {
          let item = this.allEquipmentArr.find(
            (item) => item.instanceCode == instanceCode
          );
          if (item) {
            return this.getDeviceType(
              item.vipCode,
              item.deviceVersionCode,
              item.vipName
            );
          }
        };
      },
    },
    getOdefinition: {
      get() {
        return function (id) {
          let item = this.odefinitionOptions.find((item) => item.id == id);
          if (item) {
            return item.name.split(" ")[0];
          }
        };
      },
    },
    getGroupItem: {
      get() {
        return function (innerGroupId) {
          let item = this.globalAllGroupList.find(
            (item) => item.id == innerGroupId
          );
          if (item) {
            return item;
          } else {
            return {
              id: -1,
              groupName: "所有分组",
              instanceList: [],
            };
          }
        };
      },
    },
    getDeviceType: {
      get() {
        return function (vipCode, deviceVersionCode, vipName) {
          let item = buyCode.deviceTypeOptions.find(
            (item) => item.vipCode == vipCode || item.vipName == vipName
          );
          if (item) {
            return `${item.vipType}${deviceVersionCode.substring(1)}`;
          } else {
            if (deviceVersionCode) {
              const customVipType =
              vipName.length >= 2 ? vipName.substring(0, 2) : "定制";
              return `${customVipType}${deviceVersionCode.substring(1)}`;
            } else {
              return "";
            }
          }
        };
      },
    },
    getChannelCode: {
      get() {
        return function (status) {
          let item = this.channelCodeOptions.find(
            (item) => item.type == status
          );
          if (item) {
            return item.value;
          }
        };
      },
    },
    getChannelCodeType: {
      get() {
        return function (status) {
          let item = this.channelCodeOptions.find(
            (item) => item.value == status
          );
          if (item) {
            return item.type;
          }
        };
      },
    },
  },
  methods: {
    ...mapMutations("perpetual", ["SET_FULLSCREEN", "SET_INITODEFINITION"]),
    ...mapMutations("common", ["SET_GLOBALALLGROUPLIST"]),
    // 启动前请求
    getserverToken() {
      let data = {
        instanceCode: this.instanceCode,
      };
      serverToken(data).then((res) => {
        if (res.code == 200) {
          this.$common.gteReportPage(
            "打开云手机页面",
            "phone",
            this.serverTokenData.instanceCode
          );
          this.serverTokenData = res.data;
          this.serverTokenData.odefinition = this.handleInitOdefinition();
          this.serverTokenData.channelCode = this.getChannelCode(
            this.$route.query.type
          );
          this.handleCallbacks();
          this.armCloud = new ArmcloudEngine(this.serverTokenData);
        }
      });
    },
    // 工具操作
    menuRorClick(text) {
      switch (text) {
        case "刷新":
          this.handleRefresh();
          break;
        case "全屏":
          this.screenSize(true);
          break;
        case "截图":
          this.consoleShow = false;
          this.handlePrintscreen(true);
          break;
        case "剪切板":
          this.consoleShow = false;
          this.shearShow = true;
          break;
        case "音量+":
          this.volumeControl("add");
          break;
        case "音量-":
          this.volumeControl("subtract");
          break;
        case "重启":
          this.consoleShow = false;
          this.showDialog = true;
          break;
        case "摇一摇":
          this.consoleShow = false;
          this.handleShake();
          break;
        case "退出":
          this.armCloud.quitCloudPhone();
          break;
        default:
          console.error("text名称不匹配");
      }
    },
    // 底部操作事件
    ysjclick(type) {
      this.consoleShow = false;
      this.armCloud.sendCommand(type);
    },
    // 音量加减
    volumeControl(type) {
      this.armCloud.volumeControl(type);
    },
    handlePrintscreen() {
      let data = {
        instanceCodes: [this.instanceCode],
        quality: 3,
        fullQuality: 50,
        pictureQuality: 50,
        isBdSync: true,
        scale: 576,
      };
      hsOrBdScreenshot(data).then((res) => {
        if (res.code == 200) {
          let fileName =
            this.atInstance.instanceName + "-" + this.$common.getCurrentTime();
          this.armCloud.printscreenCloudPhone(res.data[0].url, fileName);
        }
      });
    },

    // 是否全屏
    screenSize(type) {
      this.isFloat = type;
      let floatObj = {
        id: this.instanceCode,
        isFloat: type,
      };
      this.SET_FULLSCREEN(
        this.$common.checkAndUpdateArray(this.fullScreen, floatObj, "id")
      );
      this.armCloud.resizeShowVideo();
    },
    // 侧边栏显示隐藏
    handleMenuShow() {
      this.menuShow = !this.menuShow;
      this.armCloud.resizeShowVideo();
    },
    // 悬浮窗
    xuanfuchuan() {
      this.consoleShow = true;
    },
    // 切换云手机
    onCutPhone(item) {
      if (this.instanceCode != item.instanceCode) {
        this.armCloud
          .cutCloudPhone(
            item.instanceCode,
            this.getChannelCodeType(item.channelCode)
          )
          .then(() => {
            this.showPopover = false;
            this.consoleShow = false;
          });
      } else {
        this.showPopover = false;
        this.consoleShow = false;
      }
    },
    // 切换清晰度
    onCutOdefinition(type) {
      if (type != this.odefinitionValue) {
        this.armCloud.cutOdefinition(type).then((res) => {
          if (res.code == 200) {
            this.odefinitionValue = res.data;
            this.showOdefinition = false;
            let target = {
              id: this.instanceCode,
              type: type,
            };
            this.SET_INITODEFINITION(
              this.$common.checkAndUpdateArray(
                this.initOdefinition,
                target,
                "id"
              )
            );
          }
        });
      } else {
        this.showOdefinition = false;
      }
    },
    // 切换分组
    onGroupItem(id) {
      if (this.innerGroupId != id) {
        this.innerGroupId = id;
        this.showPopover = false;
      } else {
        this.showPopover = false;
      }
    },
    formatSeconds(totalSeconds) {
      // 计算各时间单位
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      // 生成单位映射
      const units = ["天", "小时", "分"];
      // 构建结果数组
      const parts = [];
      if (days > 0) parts.push(`${days}${units[0]}`);
      if (hours > 0) parts.push(`${hours}${units[1]}`);
      if (minutes > 0 && totalSeconds < 86400)
        parts.push(`${minutes}${units[2]}`);
      // 处理全0情况
      if (parts.length === 0) return `0${units[3]}`;
      return parts.join("");
    },
    // 重启云手机
    dialogConfim() {
      let data = {
        instanceCodes: [this.instanceCode],
      };
      commandreboot(data)
        .then((res) => {
          if (res.code == 200) {
            this.showDialog = false;
            Toast("云手机将在一分钟内重启，期间无法操作！");
          }
        })
        .catch((err) => {
          this.showDialog = false;
        });
    },
    confirmModel(value) {
      this.armCloud.sendInputClipper(value).then(() => {
        this.shearShow = false;
      });
    },
    confirms(msg) {
      this.dialogShow = msg;
      this.menuRorClick("退出");
    },
    // 自动复制实体手机剪切板
    getClipboardContent() {
      if (navigator.clipboard) {
        navigator.clipboard
          .readText()
          .then((text) => {
            this.confirmModel(text);
          })
          .catch((err) => {
            console.error("无法访问剪贴板：" + err);
          });
      }
    },
    // 初始化是否全屏启动云手机
    handleisFullScreen() {
      this.fullScreen.forEach((item) => {
        if (this.instanceCode == item.id) {
          this.isFloat = item.isFloat;
        }
      });
    },
    getInstancelist() {
      instancelist().then((res) => {
        if (res.code == 200) {
          let instanceList = res.data;
          groupList().then((res) => {
            if (res.code == 200) {
              this.allGroupList = res.data;
              this.allGroupList.unshift({
                id: -1,
                groupName: "所有分组",
                instanceList: instanceList,
              });
              this.SET_GLOBALALLGROUPLIST(this.allGroupList);
              this.handAllEquipmentArr();
              this.getserverToken();
            }
          });
        }
      });
    },
    //所有设备list以及当前设备item
    handAllEquipmentArr() {
      let item = this.globalAllGroupList.find((item) => item.id == -1);
      if (item) {
        this.allEquipmentArr = item.instanceList;
        let itemObj = this.allEquipmentArr.find(
          (item) => item.instanceCode == this.instanceCode
        );
        if (itemObj) {
          this.atInstance = itemObj;
          this.atInstance = itemObj;
        }
      }
    },
    // 当前默认清晰度
    handleInitOdefinition() {
      const findItem = this.initOdefinition.find(
        (item) => item.id == this.instanceCode
      );
      if (findItem) {
        return findItem.type;
      } else {
        return 2;
      }
    },
    // 处理刷新
    handleRefresh() {
      this.armCloud.refreshCloudPhone();
    },
    handleShake() {
      if (this.isFloat) {
        this.shakeShow = true;
        this.$nextTick(() => {
          const container = document.querySelector(".shakeAnimation");
          container.classList.add("shake-animation");
        });
        // 执行操作
        setTimeout(() => {
          this.armCloud.shakeCloudPhone();
          this.shakeShow = false;
        }, 500);
        // 关闭动画
        setTimeout(() => {
          const container = document.querySelector(".shakeAnimation");
          container.classList.remove("shake-animation");
          this.shakeShow = false;
        }, 1000);
      } else {
        this.$nextTick(() => {
          const container = document.querySelector(".lastItemShake");
          container.classList.add("shake-animation");
        });
        // 执行操作
        setTimeout(() => {
          this.armCloud.shakeCloudPhone();
        }, 500);
        // 关闭动画
        setTimeout(() => {
          const container = document.querySelector(".lastItemShake");
          container.classList.remove("shake-animation");
        }, 1000);
      }
    },
    // 云手机回调函数
    handleCallbacks() {
      let that = this;
      if (this.atInstance.channelCode == "baidu") {
        this.serverTokenData.callbacks = {
          // 每秒触发一次，回调当前运行信息
          onRunInformation: (type, info) => {
            this.netDelay = info.netDelay <= 500 ? info.netDelay : 500;
          },
          // 初始化
          onInit: (code, msg) => {
            // console.log("onInit:", code, msg);
          },
          // 连接成功
          onConnectSuccess: () => {
            this.transitionShow = false;
            this.getClipboardContent();
          },
          //连接失败
          onConnectFail: (code) => {
            console.log("onConnectFail:", code, new Date());
          },
          // 云机复制字符串
          onOutputClipper: (code) => {
            if (navigator.clipboard) {
              navigator.clipboard
                .readText()
                .then((text) => {
                  if (text != code) {
                    this.$common.copy(code.replace(/"/g, ""), "");
                  }
                })
                .catch((err) => {
                  console.error("无法访问剪贴板：" + err);
                });
            }
          },
          // 播放异常
          onErrorMessage: (code) => {
            if (code == 196613) {
              this.dialogName = "云手机已被其它客户端操作-2分钟后重新连接";
            } else if (code == 196614) {
              this.dialogName = "长时间未操作,已退出云手机";
            } else if (code == 196626) {
              this.dialogName = "云手机已到期!";
            } else {
              this.dialogName = "云手机连接超时，请重新连接!错误码：" + code;
            }
            this.dialogShow = true;
          },
          //屏幕旋转方向回调
          onRotation: (code, result) => {
            this.direction = result;
          },
        };
      }
      if (this.atInstance.channelCode == "intelligent") {
        this.serverTokenData.callbacks = {
          // 每秒触发一次，回调当前运行信息
          onPlayInfo: (info) => {
            this.netDelay = info.fps <= 500 ? info.fps : 500;
          },
          onInitSuccess: () => {
            console.log("初始化成功");
          },
          onInitFail: (code) => {
            console.log("初始化失败:" + code);
          },
          // 连接失败
          onStartFail: (code) => {
            console.log("链接失败:" + code);
          },

          // 连接成功
          onStartSuccess: () => {
            setTimeout(() => {
              this.transitionShow = false;
            }, 200);
            this.getClipboardContent();
          },
          // 播放异常
          onError: (code) => {
            if (code == 60309009) {
              this.dialogName = "云手机已被其它客户端控制";
            } else if (code == 60309014) {
              this.dialogName = "长时间未操作,已退出云手机";
            } else {
              this.dialogName = "云手机连接超时，请重新连接!错误码：" + code;
            }
            this.dialogShow = true;
          },
          // 云机复制字符串
          onOutClipperChange: (code) => {
            if (navigator.clipboard) {
              navigator.clipboard
                .readText()
                .then((text) => {
                  if (text != code) {
                    this.$common.copy(code.replace(/"/g, ""), "");
                  }
                })
                .catch((err) => {
                  console.error("无法访问剪贴板：" + err);
                });
            }
          },
          //屏幕旋转方向回调
          onRotationChange: (rotation) => {
            console.log("onRotation:", rotation, new Date());
            this.direction = rotation;
          },
        };
      }
      if (this.atInstance.channelCode == "huawei") {
        this.serverTokenData.callbacks = {
          // 初始化成功钩子
          onInitSuccess() {},
          // 初始化失败钩子
          onInitFail(err) {
            console.error(err);
          },
          // 当前运行信息回调
          netStateChange(delay, bitrate) {
            that.netDelay = delay <= 500 ? delay : 500;
          },
          // 初始化连接成功钩子
          onConnectSuccess(res) {
            setTimeout(() => {
              that.transitionShow = false;
            }, 2000);
            // that.getVideoFirstFrame();
          },
          // 画面第一帧回调
          onRenderedFirstFrame(res) {
            // that.transitionShow = false;
          },

          // 连接失败钩子
          onConnectFail(err) {
            console.log("连接失败回调");
            that.dialogName = "云手机连接错误，请重新连接!";
            that.dialogShow = true;
          },
          // 当前云手机屏幕方向
          onRotatePlayer(data) {
            if (data == "PORTRAIT") that.direction = 0;
            if (data == "REVERSE_LANDSCAPE") that.direction = 1;
          },
          // 会话标识无效或失效
          onAuthFailure() {
            console.log("会话失效");
          },
          // 监听用户越权操作(没有云手机的操作权限)
          onUltraVires(phoneIds, msg) {
            console.log("用户越权操作", phoneIds, msg);
          },
          // 连接终止
          onStoped() {
            that.dialogName = "云手机连接错误，请重新连接!";
            that.dialogShow = true;
          },
          // 云手机复制字符串回调
          clipboardDataChange(code) {
            if (navigator.clipboard) {
              navigator.clipboard
                .readText()
                .then((text) => {
                  if (text != code) {
                    that.$common.copy(code.replace(/"/g, ""), "");
                  }
                })
                .catch((err) => {
                  console.error("无法访问剪贴板：" + err);
                });
            }
          },
        };
      }
    },
    // 获取video元素第一帧并回调
    getVideoFirstFrame() {
      try {
        const container = document.getElementById("phoneBoxId");
        // const video = container.querySelector("video");
        const video = document.getElementsByTagName("video");

        if (!video) {
          setTimeout(() => {
            this.getVideoFirstFrame();
          }, 100);
          return;
        } else {
          this.transitionShow = false;
        }
        return;
        // 设置canvas尺寸与video相同
        video.addEventListener(
          "loadedmetadata",
          () => {
            this.transitionShow = false;
            this.getClipboardContent();
          },
          { once: true }
        );
        // 处理错误
        video.addEventListener("error", (err) => {
          this.getVideoFirstFrame();
        });
      } catch (error) {
        console.log(error);
        this.getVideoFirstFrame();
      }
    },
  },
};
</script>
  
  <style lang="less" scoped>
.Fade-enter,
.Fade-leave-to {
  opacity: 0;
  transform: scale(0);
}
.Fade-enter-to,
.Fade-leave {
  opacity: 1;
}

.Fade-enter-active,
.Fade-leave-active {
  transition: all 0.5s ease;
}
.textFade-enter,
.textFade-leave-to {
  opacity: 0;
  transform: scale(0);
}
.textFade-enter-to,
.textFade-leave {
  opacity: 1;
}

.textFade-enter-active,
.textFade-leave-active {
  transition: all 0.3s ease;
}
.cloudPhone {
  width: 100%;
  height: 100%;
  position: relative;
  .text1 {
    position: absolute;
    z-index: 1000;
    color: #fff;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .phoneBack1 {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 99;
  }
  // .initTransition {
  //   width: 100%;
  //   height: 100%;
  //   position: absolute;
  //   display: flex;
  //   align-items: center;
  //   justify-content: center;
  //   .text {
  //     position: absolute;
  //     z-index: 9999;
  //     color: #fff;
  //   }
  //   .phoneBack1 {
  //     position: absolute;
  //     width: 100%;
  //     height: 100%;
  //     left: 0;
  //     top: 0;
  //     z-index: 99;
  //   }
  // }
  // .initTransition::before {
  //   content: "";
  //   position: absolute;
  //   top: 0;
  //   left: 0;
  //   right: 0;
  //   bottom: 0;
  //   background: url("@/assets/imgs/phoneBack1.png") center/cover no-repeat;
  //   filter: blur(1px);
  //   z-index: 99;
  // }
  .phoneBox {
    width: 100%;
    height: 100%;
    padding: 40px 40px 40px 0;
    background-color: #393939;
  }
  .phoneBox_menu {
    padding: 40px 0 40px 0;
  }
  .phoneBox_qp {
    padding: 0;
  }
  #phoneBoxId {
    background-color: #393939;
    width: 100% !important;
    height: 100% !important;
  }
  .head {
    width: 100%;
    height: 40px;
    background: #393939;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    .headLeft {
      display: flex;
      align-items: center;
      .group-popover {
        background: #525252;
        border-radius: 30px;
        width: 120px;
        margin-left: 12px;
        .groupNowadayBox {
          display: flex;
          align-items: center;
          height: 100%;
          padding: 5px 7px;
          height: 30px;

          .groupNowaday {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-weight: 500;
            font-size: 14px;
            color: #fff;
            width: 90px;
            height: 18px;
            line-height: 18px;
          }
          .direction {
            width: 10px;
            height: 10px;
            margin-left: 4px;
          }
        }
      }
      .popover-odefinition {
        min-width: 110px;
      }
    }
    .headerRight {
      img {
        width: 40px;
        height: 100%;
      }
    }
  }

  .sidebar {
    width: 40px;
    height: 100%;
    background: #393939;
    font-size: 12px;
    font-weight: 400;
    color: #fff;
    position: absolute;
    top: 0;
    right: 0;
    padding-top: 40px;
    padding-bottom: 40px;
    .last {
      margin-top: 24px;
    }
    img {
      width: 28px;
      height: 28px;
    }
  }
  .directionDegrees {
    img {
      transform: rotate(90deg);
    }
  }
  .base {
    width: 100%;
    height: 40px;
    background: #393939;
    display: flex;
    position: absolute;
    bottom: 0;
    right: 0;
    div {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 28px;
        height: 28px;
      }
    }
  }
}
.group-list {
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding: 6px 0;
  text-align: center;
  min-width: 120px;
  max-height: 552px;
  cursor: pointer;
  .item {
    padding: 6px;
    font-weight: 500;
    font-size: 14px;
    color: #fff;
  }
  .active {
    color: #886df3;
  }
}
.group-list-left {
  transform: rotate(90deg);
  padding: 12px 0px;
}
.odefinition-list {
  width: 110px;
}
.popupConsole {
  height: 100%;
  width: 320px;
  // width: 100%;
  background-color: rgb(4, 7, 8);
  color: #fff;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .card {
    background: #4e4e4e;
    padding: 10px;
    position: relative;
    .top {
      align-items: center;
      background: #4e4e4e;
      display: flex;
      justify-content: space-between;
      .left {
        align-items: center;
        display: flex;
        margin-right: 8px;
        .ico {
          height: 32px;
          width: 32px;
          margin-right: 10px;
        }
        .detail {
          text-align: left;
          .alias {
            color: #01ef03;
            overflow: hidden;
            padding: 1px 0;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 80px;
          }
          .id {
            color: #886df3;
            padding: 1px 0;
          }
        }
      }
      .control {
        align-items: center;
        display: flex;
        justify-content: space-between;
        .fresh {
          border: 1px solid #01ef03;
          border-radius: 20px;
          color: #fff;
          display: flex;
          margin-left: 5px;
          padding: 6px 10px;
          line-height: 16px;
          .freshImgicon {
            background-image: url("@/assets/icons/shuaxin2.png");
            background-position: 50%;
            background-repeat: no-repeat;
            background-size: contain;
            height: 16px;
            margin-right: 4px;
            width: 16px;
          }
        }
        .quitFloat {
          border: 1px solid #886df3;
          // border: 0;
          // background-color: #886df3;
          color: #fff;
          height: 30px;
          .imgicon {
            background-image: url("@/assets/icons/fullScreenImg1.png");
            background-position: 50%;
            background-repeat: no-repeat;
            background-size: contain;
            height: 16px;
            margin-right: 4px;
            width: 16px;
          }
        }
      }
    }
  }
  .cardTwo {
    background: #333;
    .partTop {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      row-gap: 12px;
      padding: 16px 0;
      .last {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        .icoBox {
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #886df3;
          border-radius: 40px;
          margin-bottom: 4px;
          .ico {
            width: 32px;
            height: 32px;
          }
        }
      }
    }
    .partBottom {
      padding: 0 10px;
      .ysjcBox {
        border-top: 1px solid #959595;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        padding: 12px 0;
        .common {
          width: 33%;
          img {
            width: 40px;
            height: 40px;
          }
        }
      }
    }
  }
  .cardThree {
    display: flex;
    align-items: center;
    padding: 10px 20px;
    justify-content: space-between;
    .group-popover {
      background: #525252;
      border-radius: 30px;
      width: 120px;
      .groupNowadayBox {
        display: flex;
        align-items: center;
        height: 100%;
        padding: 5px 7px;
        height: 30px;

        .groupNowaday {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-weight: 500;
          font-size: 14px;
          color: #fff;
          width: 90px;
          height: 18px;
          line-height: 18px;
        }
        .direction {
          width: 10px;
          height: 10px;
          margin-left: 4px;
        }
      }
    }
    .popover-odefinition {
      width: 110px;
    }
  }
  .consoleBottom {
    .shebei_title {
      display: flex;
      align-items: center;
      justify-content: space-between;

      padding: 8px 12px;
      background: hsla(0, 0%, 88%, 0.1);
      margin-bottom: 12px;
      img {
        width: 40px;
        height: 40px;
        border-radius: 20px;
      }
      .shebei_content {
        // margin-left: 16px;
        text-align: left;
        color: #886df3;
        flex: 1;
        .p1 {
          font-weight: 500;
          font-size: 15px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-bottom: 6px;
        }
        .p2 {
          .id {
            font-weight: 500;
            font-size: 12px;
          }
        }
      }
      .instanceItem {
        font-weight: 400;
        font-size: 13px;
        color: #a9adb6;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: space-between;
        height: 100%;
        .devices-status {
          align-items: center;
          display: flex;
          flex-direction: row;
          font-size: 10px;
          .status-div-normal {
            background-color: #23bc05;
            border-radius: 50%;
            height: 8px;
            margin-right: 8px;
            width: 8px;
          }
          .status-span-normal {
            color: #23bc05;
          }
        }
      }
    }
    .active {
      border: 1px solid #886df3;
    }
  }
}
.topDirection {
  transform: rotate(90deg) translate(320px, -55px);
  transform-origin: right top;
  max-height: 375px;
  overflow-y: auto;
  overflow-x: hidden;
  touch-action: manipulation;
  scrollbar-width: none;
}
.leftDirection {
  .consoleBottom {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    touch-action: manipulation;
    scrollbar-width: none;
  }
}
.shakePopup {
  background-color: #333333;
  padding: 40px 60px;
  border-radius: 10px;
  .shakeAnimation {
    width: 90px;
    height: 90px;
  }
}
.shake-animation {
  animation: shake 2s cubic-bezier(0.36, 0.07, 0.19, 0.97) infinite;
}

@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }
  30%,
  50%,
  70% {
    transform: translate3d(-3px, 0, 0);
  }
  40%,
  60% {
    transform: translate3d(3px, 0, 0);
  }
}
</style>